import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BriefcaseIcon, WrenchScrewdriverIcon, HomeIcon, ClipboardDocumentCheckIcon, PaintBrushIcon, BuildingOfficeIcon } from "@heroicons/react/24/outline";

const SelectRole = ({ usuario, setUsuario, roles, originalPath }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSelect = async (rol_id) => {
        setLoading(true);
        try {
            const res = await fetch(`${window.REACT_APP_API_ENDPOINT}/api/users/asignar-rol`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ rol_id }),
            });

            const resUsuario = await fetch(`${window.REACT_APP_API_ENDPOINT}/api/users/current-user`, {
                credentials: "include"
            });
            const data = await resUsuario.json();
            setUsuario(data.user);
            navigate(originalPath || "/", { replace: true });
        } catch (error) {
            console.error("Error asignando rol:", error);
        } finally {
            setLoading(false);
        }
    };

    const iconMap = {
        inversor: <BriefcaseIcon className="h-12 w-12 text-blue-600" />,
        constructor: <WrenchScrewdriverIcon className="h-12 w-12 text-yellow-600" />,
        propietario: <HomeIcon className="h-12 w-12 text-green-600" />,
        perito: <ClipboardDocumentCheckIcon className="h-12 w-12 text-red-600" />,
        interiorista: <PaintBrushIcon className="h-12 w-12 text-pink-500" />,
        gestor_inmobiliario: <BuildingOfficeIcon className="h-12 w-12 text-indigo-600" />
    };


    return (
        <div className="max-w-4xl mx-auto mt-10 p-6 bg-white rounded shadow-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Selecciona tu rol en reformista.net</h2>
            <p className="text-gray-600 mb-6">
                Elige el perfil que mejor se ajuste a tu uso de la plataforma:
            </p>

            <div className="grid md:grid-cols-2 gap-6">
                {roles.map((rol) => (
                    <div
                        key={rol.id}
                        className="border border-gray-300 rounded-lg p-6 bg-gray-50 shadow hover:shadow-lg transition cursor-pointer flex flex-col items-center text-center"
                        onClick={() => handleSelect(rol.id)}
                    >
                        <div className="mb-4">
                            {iconMap[rol.nombre] || <BriefcaseIcon className="h-12 w-12 text-gray-400" />}
                        </div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">{rol.label}</h3>
                        <p className="text-gray-600 text-sm mb-4">{rol.descripcion}</p>
                        <button className="mt-auto bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                            Seleccionar
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SelectRole;
